(function(){
    'use strict'

    angular
    .module('app.proyectos')
    .controller('proyectos.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiProyectos = 'api/Proyectos'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
            clienteId: 0,
            centroCostoId: 0
        };

        vm.title = 'Proyectos';
        vm.id = $routeParams.id ? $routeParams.id : 0;
        vm.clientes = [];
        vm.centrosCosto = [];

        const promiseClientes = getComboData(vm.clientes, 'api/Clientes', [companiaId], 'Error al obtener los clientes.');

        get();

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function get(){

            $q.all([promiseClientes])
            .then(function(){
                if(vm.id != 0){
                    ApiBaseService.remoteController = apiProyectos;
                    var promise = ApiBaseService.getAll([companiaId, vm.id]);

                    promise
                    .then(function(data){
                        vm.data = Object.assign(vm.data, data);

                        vm.data.centroCostoId = 0;

                        const promiseCentrosCosto = getComboData(vm.centrosCosto, 'api/CentrosCosto/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los centros de costo.');

                        promiseCentrosCosto.then(function(){
                            vm.data.centroCostoId = data.centroCostoId;
                        });
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }                
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al obtener los datos: ' + error.data.Message);
                        break;
                }
            }); 

        };

        function doFormValidations()
        {
            validateSelectProperty('clienteId');
            validateSelectProperty('centroCostoId');
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiProyectos;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiProyectos;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/proyectos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                clienteId: 0,
                centroCostoId: 0
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(property){
            if(vm.data[property] == 0){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        vm.onSelectChanged = function(property){
            validateSelectProperty(property);

            if(property=='clienteId')
            {
                if(vm.data.clienteId != 0)
                {
                    const promiseCentrosCosto = getComboData(vm.centrosCosto, 'api/CentrosCosto/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los centros de costo.');

                        promiseCentrosCosto.then(function(){
                            vm.data.centroCostoId = 0;
                        });
                }
            }
        };

    }
})();